<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <BannerNotification />
    <BasicCreatePageHeader
      :title="componentName"
      :handleCreate="handleCreateInstance"
    />
    <BasicCreateForm :formData="formData" :componentId="componentId" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import BasicCreateForm from "@/components/ComponentModule/BasicComponent/BasicCreateForm";
import BasicCreatePageHeader from "@/components/ComponentModule/BasicComponent/BasicCreatePageHeader";

export default {
  name: "BasicCreatePage",
  components: {
    BasicCreateForm,
    BannerNotification,
    BasicCreatePageHeader
  },
  data() {
    return {
      formData: { attributes: {}, instance_name: "" }
    };
  },
  props: {
    componentId: {
      type: String,
      required: true
    }
  },
  computed: {
    componentName() {
      if (
        this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        )
      ) {
        return this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        ).name;
      } else {
        return "";
      }
    },
    ...mapGetters(["getAllComponent", "getRegion", "currentUser"])
  },
  async mounted() {
    await this.$store.dispatch(Actions.FETCH_COMPONENT_DATA, {
      region: this.getRegion,
      componentId: this.componentId
    });
  },
  methods: {
    handleCreateInstance() {
      this.$store
        .dispatch(Actions.CREATE_COMPONENT_DATA, {
          formData: this.formData,
          region: this.getRegion,
          componentId: this.$route.params.compId,
          user: this.currentUser.email
        })
        .then(() => {
          this.$router.push(`/component/${this.$route.params.compId}`);
        });
    }
  }
};
</script>
